import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth.js";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const {
		loading,
		user,
		isAuth,
		isImpersonating,
		handleLogin,
		handleLogout,
		handleImpersonate,
		handleStopImpersonate
	} = useAuth();

	return (
		<AuthContext.Provider
			value={{
				loading,
				user,
				isAuth,
				isImpersonating,
				handleLogin,
				handleLogout,
				handleImpersonate,
				handleStopImpersonate
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };
